import { render, staticRenderFns } from "./MarketplaceListings.vue?vue&type=template&id=89cbf292"
import script from "./MarketplaceListings.vue?vue&type=script&lang=js"
export * from "./MarketplaceListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports